import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import jwt_decode from "jwt-decode";
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
   providedIn: 'root'
})
export class LoginapiService {
   private _authLoginUrl: any = environment.url.BASE_URL;
   private _authUrl: any = environment.url.authUrl
   private _chatbot: any = environment.url.CHAT_BOT;
   private URL: any = environment.url.API_URL;

   private _trialVersionUrl: any = `${environment.url.BASE_URL}contact-us/save`;
   userData: any;
   isLoggedIn = false;
   adminData: any;
   providerData: any;
   consumerData: any;
   token: any;
   constructor(
      private http: HttpClient,
      private router: Router,
   ) { }

   // Chatbot Start API
   dataInsertion(data) {
      return this.http.post(this._chatbot + 'chatbot/chat', data);
   }
   // Chatbot Remove Session End API
   removeSession(sessionId: string): Observable<any> {
      return this.http.post(this._chatbot + 'chat/remove-session/', { session_id: sessionId });
   }


   loginUser(value) {
      return this.http.post(this._authLoginUrl + 'account/login', value);
   }

   logOut(value) {
      return this.http.post(this._authLoginUrl + 'account/signout', value)
   }

   resetPassword(data) {
      return this.http.post(this.URL + 'account/forgot-password/confirm-verification-code', data)
   }

   trialVersion(data) {
      return this.http.post(this._authLoginUrl + 'trial-account-request', data);
   }

   getCredential() {
      return this.http.get(this._authLoginUrl + 'app-client-credentials')
   }
   getsessionStorageUser() {
      this.userData = JSON.parse(sessionStorage.getItem("user-token"));
      if (this.userData !== null) {
         var token = this.userData.idToken;
         var User = jwt_decode(token);
         var userLength: any = User["cognito:groups"].length;
         for (let i = 0; i < userLength; i++) {
            if (User["cognito:groups"][i].includes("_CONSUMER")) {
               return true;
            }
            else if (User["cognito:groups"][0].includes("_PROVIDER")) {
               return true;

            }
            else if (User["cognito:groups"][0].includes("_ADMIN")) {
               return true;

            }
            else if (User["cognito:groups"][0].includes("_LG")) {
               return true;

            }
         }

      }

   }
   getsessionStorageAdmin() {
      this.adminData = JSON.parse(sessionStorage.getItem('admin_token'));
      if (this, this.adminData !== null) {
         var token = this.adminData.idToken;
         var loginUser = jwt_decode(token);
         var userLength: any = loginUser["cognito:groups"].length;
         for (let i = 0; i < userLength; i++) {
            if (loginUser["cognito:groups"][i].includes("_ADMIN")) {
               return true;
            }
         }
      }

   }
   getsessionStorageProvider() {
      this.providerData = JSON.parse(sessionStorage.getItem('user-token'));
      if (this, this.providerData !== null) {
         var token = this.providerData.idToken;
         var loginUser: any = jwt_decode(token);
         sessionStorage.setItem('emailid', JSON.stringify(loginUser.email))
         var userLength: any = loginUser["cognito:groups"].length;
         for (let i = 0; i < userLength; i++) {
            if (loginUser["cognito:groups"][i].includes("_PROVIDER")) {
               return true;
            }
         }

      }

   }

   sendAuthCode(code) {
      let param = new HttpParams().set('authcode', code)
      return this.http.get(this._authLoginUrl + 'tesla/authcode', { params: param })
   }

   getHealthReport() {
      return this.http.get(this._chatbot + 'actuator/health')
   }

   // Chatbot Start API
   dataInsertionFt(data) {
      let userToken = JSON.parse(sessionStorage.getItem('user-token'));
      // console.log(userToken)
      let idToken = userToken.idToken;
      let headers = new HttpHeaders({
         'id-token': idToken
      });
      const threshId = sessionStorage.getItem('threadId');
      if (threshId) {
         headers = headers.set('threadId', threshId);
      }
      return this.http.post(this._chatbot + 'chatbot/chat/ft', data, { headers });
   }

   copilotEndSession(session_id: string) {
      return this.http.post(this._chatbot + `chatbot/sessions/${session_id}/cancel`, {});
   }
}

